import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ChartType, GoogleChartComponent } from 'angular-google-charts';
import { getCssVariableValue } from 'src/app/helpers/theme.helper';
import { EventService } from 'src/app/services/event.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'rfr-timeline-chart',
  templateUrl: './rfr-timeline-chart.component.html',
  styleUrls: ['./rfr-timeline-chart.component.scss'],
})
export class RfrTimelineChartComponent implements OnInit {
  timelineTextColor = '#009B8D';
  chartType = 'Timeline';

  chartColumns = [
    { type: 'string', id: 'Person' },
    { type: 'string', id: 'Status' },
    { type: 'string', id: 'Color' },
    { type: 'date', id: 'Start Time' },
    { type: 'date', id: 'End Time' }
  ];

  myData = [
    ['London', 8136000],
    ['New York', 8538000],
    ['Paris', 2244000],
    ['Berlin', 3470000],
    ['Kairo', 19500000]
  ];

  chartData = [
    ['User 1', 'IN', 'color: #90caf9', new Date(2025, 7, 25, 10, 0), new Date(2025, 7, 25, 11, 0)],
    ['User 1', 'OUT', 'color: #90caf9', new Date(2025, 7, 25, 11, 15), new Date(2025, 7, 25, 12, 0)],
    ['User 2', 'IN', 'color: #90caf9', new Date(2025, 7, 26, 9, 30), new Date(2025, 7, 26, 10, 30)],
    ['User 2', 'OUT', 'color: #90caf9', new Date(2025, 7, 26, 10, 45), new Date(2025, 7, 26, 11, 15)],
    ['User 3', 'IN', 'color: #90caf9', new Date(2025, 7, 26, 8, 0), new Date(2025, 7, 26, 8, 45)],
    ['User 3', 'OUT', 'color: #90caf9', new Date(2025, 7, 26, 9, 0), new Date(2025, 7, 26, 9, 30)]
  ];

  // chartOptions = {
  //   timeline: { showRowLabels: false, colorByRowLabel: false },
  //   backgroundColor: '#f5f5f5',
  //   height: 500,
  //   hAxis: {
  //     // minValue: new Date(`2025-04-08T00:00:00`),  // Start at 12:00 AM
  //     // maxValue: new Date(`2025-04-08T23:59:59`), // End at 11:59 PM
  //     viewWindow: {
  //       min: new Date(`2025-04-08T00:00:00`),
  //       max: new Date(`2025-04-08T23:59:59`)
  //     },
  //     format: 'HH:mm'
  //   },
  //   // viewWindow: {
  //   //   min: new Date(`2025-04-08T00:00:00`),  // Start at 12:00 AM
  //   //   max: new Date(`2025-04-08T23:59:59`), // End at 11:59 PM
  //   // },
  // };

  chartOptions = {
    timeline: {
      colorByRowLabel: false,
      showRowLabels: true, // Keep row labels visible
      barLabelStyle: {
        color: 'transparent', // Hide text inside timeline cells
      }
    },
    columns: [
      { type: 'string', id: 'Person' },
      { type: 'string', id: 'Status' },
      { type: 'string', id: 'Color' },
      { type: 'date', id: 'Start Time' },
      { type: 'date', id: 'End Time' }
    ],
    hAxis: {
      textStyle: {
        color: 'black', // Color of the labels on the H axis
        fontSize: 12,
        bold: true
      },
      titleTextStyle: {
        color: 'black', // Color of the title of the H axis
        fontSize: 14,
        italic: true
      },
      minValue: new Date('2025-04-08T00:00:00'),
      maxValue: new Date('2025-04-08T23:59:59'),
      format: 'HH:mm',
      gridlines: { color: 'black', count: 25 }
    },
    vAxis: {
      titleStyle: {
        color: 'black', // Set text color to white
        fontSize: 12, // Optional: Adjust font size for better visibility
        italic: true,
        bold: true,
      },
    },
    animation: {
      duration: 250,
      easing: 'ease-in-out',
      startup: true
    },
    colors: ['#7D7A7A', '#0d6efd', '#198754', '#dc3545'],
    backgroundColor: '#e0e0e0',
    alternatingRowStyle: false,
    avoidOverlappingGridLines: false
  };

  public changingChart = {
    title: 'Changing Chart',
    type: ChartType.Timeline,
    data: [
      // ['User 1', 'Shift', new Date(2025, 7, 25, 8, 0), new Date(2025, 7, 25, 24, 0)],
      // ['User 1', 'IN', new Date(2025, 7, 25, 10, 0), new Date(2025, 7, 25, 11, 0)],
      // ['User 1', 'OUT', new Date(2025, 7, 25, 11, 0), new Date(2025, 7, 25, 12, 0)],
      // ['User 1', 'IN', new Date(2025, 7, 25, 12, 0), new Date(2025, 7, 25, 15, 0)],
      // ['User 1', 'OUT', new Date(2025, 7, 25, 15, 0), new Date(2025, 7, 25, 23, 59)],
      // ['User 2', 'IN', new Date(2025, 7, 25, 9, 30), new Date(2025, 7, 25, 10, 30)],
      // ['User 2', 'OUT', new Date(2025, 7, 25, 10, 45), new Date(2025, 7, 25, 11, 15)],
      // ['User 3', 'IN', new Date(2025, 7, 25, 8, 0), new Date(2025, 7, 25, 8, 45)],
      // ['User 3', 'OUT', new Date(2025, 7, 25, 9, 0), new Date(2025, 7, 25, 9, 30)]
    ],
    columns: [
      { type: 'string', id: 'Person' },
      { type: 'string', id: 'Status' },
      { type: 'string', role: 'style' },
      { type: 'date', id: 'Start Time' },
      { type: 'date', id: 'End Time' }
    ],
    // options: {
    //   animation: {
    //     duration: 250,
    //     easing: 'ease-in-out',
    //     startup: true
    //   },
    //   timeline: { showRowLabels: false, colorByRowLabel: false },
    //   backgroundColor: '#f5f5f5',
    //   colors: ['#1CCCCF', '#1e88e5', '#43a047'],
    //   height: 500,
    //   hAxis: {
    //     minValue: new Date(`2025-04-08T00:00:00`),  // Start at 12:00 AM
    //     maxValue: new Date(`2025-04-08T00:00:00`), // End at 11:59 PM
    //     format: 'HH:mm', // Display hours in 24-hour format
    //     gridlines: { count: 25 }, // 24-hour format (0h to 24h with 1-hour steps)
    //   }
    // }
  };

  @ViewChild('chart', { static: true })
  public chart!: GoogleChartComponent;
  @Input() date = '';
  @Input() shiftId = '';
  @Input() rosterId = '';
  @Input() staffId = '';
  @Input() totalDays = 1;
  constructor (private eventService: EventService,
    private toastService: ToastService
  ) {

  }

  ngOnInit() {
    // console.log(this.date, this.shifId);
    this.timelineTextColor = getCssVariableValue('--ion-text-color-base');
  }

  ngOnChanges(change: SimpleChanges) {
    // console.log(this.date, this.shifId);
    if (change['date']) {
      this.getAddedKnights();
    }
    if (change['staffId']) {
      this.getAddedKnights();
    }
  }

  chartHeight = 150;
  getAddedKnights() {
    if (!this.date)
      return;

    const split = this.date.split('-');
    const originalDate = new Date(`${split[2]}-${split[1]}-${split[0]}T10:00:00Z`);

    // Set to the start of the day (00:00:00 UTC)
    const startOfDay = new Date(originalDate);
    startOfDay.setUTCHours(0, 0, 0, 0);

    // Set to the end of the day (23:59:59 UTC)
    const endOfDay = new Date(originalDate);
    endOfDay.setUTCHours(23, 59, 59, 999);


    // this.chartOptions.hAxis.minValue = new Date(`${split[2]}-${split[1]}-${split[0]}T00:00:00`);
    // this.chartOptions.hAxis.maxValue = new Date(`${split[2]}-${split[1]}-${split[0]}T23:59:59`);

    // console.log(this.chartOptions.hAxis.minValue, this.chartOptions.hAxis.maxValue);

    this.eventService.getShiftStaffsData(this.shiftId, this.rosterId, this.date, this.totalDays, this.staffId).subscribe(res => {
      //debugger;
      //console.log(res);
      const shiftData = res.data.find((item: any) => item.type == "Shift");
      console.log(shiftData);
      // console.log(res);
      // this.chartHeight = 50 * res.data.length;
      // console.log(res.data);

      const shiftStartTime = new Date(shiftData.startTime + (shiftData.startTime.includes('Z') ? '' : 'Z'));
      shiftStartTime.setHours(shiftStartTime.getHours() - shiftData.shiftSpaceHours);
      this.chartOptions.hAxis.minValue = shiftStartTime;
      console.log(shiftStartTime);

      // this.chartOptions.hAxis.maxValue = new Date(shiftData.endTime + 'Z');
      const shiftEndTime = new Date(shiftData.endTime + (shiftData.endTime.includes('Z') ? '' : 'Z'));
      shiftEndTime.setHours(shiftEndTime.getHours() + shiftData.shiftSpaceHours);
      this.chartOptions.hAxis.maxValue = shiftEndTime;
      console.log(shiftEndTime);

      const convertedData = res.data.map((item: any) => {
        let color = '#7D7A7A';
        if (item.type == 'IN')
          color = 'color: #4caf50';
        else if (item.type == 'OUT')
          color = 'color: #f44336';

        return [
          item.userId ? item.userId : 'Shift',
          item.type ? item.type : 'OUT',
          color,
          new Date(item.startTime + (item.startTime.includes('Z') ? '' : 'Z')),
          new Date(item.endTime + (item.endTime.includes('Z') ? '' : 'Z'))
        ];
      });
      // debugger;
      console.log(convertedData);
      this.changingChart.data = convertedData;

      //console.log(res.totalUsers);
      if (res.totalUsers >= 1)
        this.chartHeight = 100 + res.totalUsers * 50;

      // console.log(this.chartHeight);

    }, err => {
      this.toastService.error(err);
    });
  }



  onChartReady(chartContainer: HTMLElement): void {
    const labels = chartContainer.getElementsByTagName('text');
    // console.log(labels);
    if (labels) {
      Array.prototype.forEach.call(labels, (label: SVGTextElement) => {
        if (label.getAttribute('text-anchor') === 'middle') {
          label.setAttribute('fill', this.timelineTextColor); // Change text color to white
        }
      });
    }
  }

}
